module.exports = __webpack_public_path__ + "img/Dil-Foods-new-logo.a9399e0c.png";